import useFilterCore from "./core/useFilterCore"

export const useFilter = () => {
    return useFilterCore()
}